angular.module("ainapp")
    .controller("brokerDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Broker Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.MonthlySalesChartFun = function () {

                $("#monthlysalesChart").kendoChart({
                    title: {
                        text: "Broker Wise Sales"
                    },
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "bar"
                    },
                    chartArea: {
                        height: 800
                    },
                    series: $scope.MonthlySalesChartData.series,
                    categoryAxis: {
                        categories: $scope.MonthlySalesChartData.categories
                    },
                    tooltip: {
                        visible: true,
                        template: "#= category #: #= value #"
                    }
                });

            }



            $scope.Init = function () {

                //                $scope.dashcounts = [];
                //                MainService.SalesDashboardCounts().then(function (response) {
                //                    $scope.dashcounts = response.data;
                //                }, function () {})


                $scope.MonthlySalesChartData = {};
                MainService.BrokerSalesChart().then(function (response) {
                    $scope.MonthlySalesChartData = response.data;
                    if ($scope.MonthlySalesChartData != null) {
                        $scope.MonthlySalesChartFun();
                    }
                }, function () {})




            }
            $scope.Init();

                        }])
